import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSleepCheckupInfoAPI } from "../examinee/sleep_checkup/SleepCheckupAPI";

export function useNavigateRegisterRingDeviceIdOrCompleted() {
  const api = useSleepCheckupInfoAPI();
  const navigate = useNavigate();
  return useCallback(
    async (sleepCheckupId: string) => {
      const info = await api.get(sleepCheckupId);
      if (info.data.recommendation_option) {
        // 受診勧奨オプションありの場合、指輪型の登録画面へ遷移
        navigate(`/examinee/ring_id_scan_introduction/${sleepCheckupId}`);
      } else {
        // 受診勧奨オプションがなしの場合、登録完了画面に遷移
        navigate("/examinee/registration_completed", {
          state: {
            sleepCheckupUuid: sleepCheckupId,
          },
        });
      }
    },
    [api, navigate]
  );
}

// リング ID の仕様は下記
//  - 全部で 15 桁 (半角英数字)
//  - 1 桁目はアルファベット大文字
//  - 4 桁目はアルファベット大文字
//  - 5 桁目はリングのサイズを表していて 7, 8, 9 のどれか
//  - 8, 9 桁目は月を表すため 01 から 12 までの数字
//  - 上記以外の桁は 0 から 9 の数字
const RING_ID_FORMAT = /^[A-Z][0-9]{2}[A-Z][7-9][0-9]{10}$/;
const HANKAKU_ALPHANUMERIC_REGEX = /[^a-zA-Z0-9]/;
export function validateRingId(ringId: string): string[] | null {
  // 形式を満たしていたらエラーなし
  if (RING_ID_FORMAT.test(ringId)) {
    // 8, 9 桁目は月を表すため 01 から 12 までの数字
    const monthDigits = parseInt(ringId.slice(7, 9));
    if (1 <= monthDigits && monthDigits <= 12) {
      return null;
    }
  }

  const errorMessages: string[] = [];
  if (ringId.length !== 15) {
    errorMessages.push("※15文字で入力してください。");
  }

  const hankakuAlphanumericErrorMessage = "※半角英数字で入力してください。";
  if (HANKAKU_ALPHANUMERIC_REGEX.test(ringId)) {
    errorMessages.push(hankakuAlphanumericErrorMessage);
  }

  // 有効な文字種のみが使用されているが形式が不正な場合
  const formatErrorMessage = "※デバイスIDが間違っています。";
  if (errorMessages.length === 0) {
    errorMessages.push(formatErrorMessage);
  }

  return errorMessages;
}
